module.exports = __webpack_public_path__ + "img/1602347120.2773a61b.png";